module.exports = __webpack_public_path__ + "img/secure-payment-logo-2.8ef33813.png";